import React from 'react';

import { getTimeFormat } from '../../../service/NavPointsUtils';
import { getTimeHHmm } from '../../../service/DateTimeUtils';
import { DownArrow, UpArrow } from '../../../icons';

const SummaryFieldFormat = {
    DEFAULT: 0,
    EMPTY: 1,
    TIME: 2,
    TIME_HHMM: 3,
    CUSTOM: 4,
};

export const summaryFields = [
    { id: 'work', title: 'tables.duty', format: SummaryFieldFormat.TIME },
    {
        id: 'workBegin',
        title: 'summaryTaskPage.start',
        format: SummaryFieldFormat.TIME_HHMM,
        totalFormat: SummaryFieldFormat.EMPTY,
    },
    { id: 'workBefore', title: 'summaryTaskPage.before', format: SummaryFieldFormat.TIME },
    {
        id: 'timeTakeoff',
        title: 'summaryTaskPage.takeOff',
        format: SummaryFieldFormat.TIME_HHMM,
        totalFormat: SummaryFieldFormat.EMPTY,
    },
    { id: 'flight', title: 'flight', format: SummaryFieldFormat.CUSTOM },
    { id: 'workAfter', title: 'summaryTaskPage.after', format: SummaryFieldFormat.TIME },
    {
        id: 'workEnd',
        title: 'summaryTaskPage.end',
        format: SummaryFieldFormat.TIME_HHMM,
        totalFormat: SummaryFieldFormat.EMPTY,
    },
    { id: 'block', title: 'tables.blockTime', format: SummaryFieldFormat.TIME },
    { id: 'night', title: 'summaryTaskPage.night', format: SummaryFieldFormat.TIME },
    { id: 'biologicalNight', title: 'summaryTaskPage.bio', format: SummaryFieldFormat.TIME },
    { id: 'independent', title: 'summaryTaskPage.indep', format: SummaryFieldFormat.TIME },
    { id: 'parking', title: 'summaryTaskPage.parking', format: SummaryFieldFormat.TIME },
    { id: 'delay', title: 'summaryTaskPage.delay', format: SummaryFieldFormat.TIME },
    { id: 'rest', title: 'summaryTaskPage.rest', format: SummaryFieldFormat.TIME },
    { id: 'dist', title: 'summaryTaskPage.distance', format: SummaryFieldFormat.DEFAULT },
    { id: 'landings', title: 'summaryTaskPage.landings', format: SummaryFieldFormat.CUSTOM },
    { id: 'pf', title: 'summaryTaskPage.pf', format: SummaryFieldFormat.CUSTOM },
];

export const getDataFormat = (id, format, data) => {
    switch (format) {
        case SummaryFieldFormat.EMPTY:
            return '';
        case SummaryFieldFormat.TIME:
            return getTimeFormat(data[id]);
        case SummaryFieldFormat.TIME_HHMM:
            return getTimeHHmm(data[id]);
        case SummaryFieldFormat.CUSTOM: {
            const flightInfo = `${getTimeFormat(data.flight)}${
                data.flight !== data.timeOnDevices && data.timeOnDevices ? ` (${getTimeFormat(data.timeOnDevices)})` : ''
            }`;
            const landingsInfo = `${data.landings}${
                data.landings !== data.landingsOnDevices && data.landingsOnDevices ? ` (${data.landingsOnDevices})` : ''
            }`;
            switch (id) {
                case 'flight':
                    return flightInfo;
                case 'landings':
                    return landingsInfo;
                case 'pf':
                    return (
                        <div>
                            {data.takeoff && <UpArrow width={15} height={20} />}
                            {data.landing && <DownArrow width={15} height={20} />}
                        </div>
                    );
            }
        }
    }
    return data[id] || '';
};
